<template>
  <Modal
    data-testid="password-modal"
    class="password-modal"
    size="md"
    :is-open="isOpen"
    @close="$emit('close')"
  >
    <div>
      <Heading class="password-modal__heading" :level="3">
        Digite sua senha para confirmar
      </Heading>
      <SingleInput
        v-model="inputPassword"
        type="password"
        class="password-modal__input"
      />
    </div>
    <template #buttonContainer>
      <ButtonContainer>
        <template #button-primary>
          <ButtonPrimary
            label="Confirmar"
            :loading="isCheckingPassword || loadingPassword"
            :disabled="isDisabled"
            @click="checkPassword"
          />
        </template>
        <template #button-secondary>
          <ButtonSecondary label="Cancelar" @click="$emit('close')" />
        </template>
      </ButtonContainer>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';
import { isBFFError } from '@/modules/common/helpers/bff';

import {
  Modal,
  Heading,
  SingleInput,
  ButtonContainer,
  ButtonPrimary,
  ButtonSecondary
} from '@warrenbrasil/nebraska-web';

import { verifyPassword } from '@/modules/trade/services/profit';

interface Props {
  isOpen: boolean;
  loadingPassword: boolean;
}
defineProps<Props>();

interface EmitEvents {
  (event: 'close'): void;
  (event: 'confirm'): void;
}
const emit = defineEmits<EmitEvents>();

const inputPassword = ref('');
const isCheckingPassword = ref(false);

const isDisabled = computed(() => {
  return Boolean(!inputPassword.value);
});

async function checkPassword() {
  try {
    isCheckingPassword.value = true;

    const isValidPassword = await verifyPassword(inputPassword.value);

    if (isValidPassword) emit('confirm');
  } catch (e) {
    let errorMessage = 'Houve um problema ao validar a senha.';

    if (isBFFError(e)) {
      errorMessage = e.error.message.formatted;
    }

    notify({
      group: 'wrn-notifications',
      text: errorMessage,
      type: NotificationTypes.error
    });
  } finally {
    isCheckingPassword.value = false;
  }
}
</script>
<style lang="less" scoped>
.password-modal {
  :deep(.base-modal--wrapper) {
    width: 592px;
    max-width: 592px;
  }

  :deep(.modal-content) {
    align-items: flex-start;
    padding: 0 @size-spacing-x1000 @size-spacing-x1000;
  }

  &__heading {
    text-align: left;
  }

  &__input {
    margin-top: @size-spacing-x600;
    width: 464px;

    :deep(.single-input__container) {
      padding: 0;
    }

    :deep(.single-input__input-password) {
      .text-p-2();
    }
  }
}
</style>
